import RestrictedModal from './RestrictedModal';
export default RestrictedModal;
